// Implements: F-UIX-008, F-UIX-014
/**
 * The `/login` screen: one container, centred on the page.
 *
 * The page is composition and nothing else — it holds no state and knows no
 * HTTP. Where a successful attempt goes is not its decision either: the route
 * validates `next` and hands the destination down as `onSuccess`, so the page
 * stays mountable from anywhere.
 */

import type { ReactElement } from "react";

import { ForgotPasswordLink } from "../../modules/auth/components/ForgotPasswordLink";
import { LoginContainer } from "../../modules/auth/containers/LoginContainer";
import styles from "./LoginPage.module.css";

export interface LoginPageProps {
  /** Called once, when the backend has recognised the credentials. */
  readonly onSuccess?: (() => void) | undefined;
}

export function LoginPage({ onSuccess }: LoginPageProps = {}): ReactElement {
  return (
    <main className={styles.page}>
      <LoginContainer
        forgotPassword={<ForgotPasswordLink />}
        onSuccess={
          onSuccess === undefined
            ? undefined
            : () => {
                onSuccess();
              }
        }
      />
    </main>
  );
}
